import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import publicProfileService from "../services/public-profile-service";

export const profileSearchSchema = z.object({
	search: z.string().optional(),
	status: z.string().optional(),
	authors: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const publicProfileQueryOptions = (
	profileId: string,
	status: string,
) => {
	return queryOptions({
		queryKey: ["publicprofile", profileId, status],
		queryFn: () =>
			publicProfileService.findByIdWithParameter({
				id: profileId,
				parameters: {
					status,
				},
			}),
	});
};

// export const useProfileMutation = (profileId?: string) => {
// 	return useMutation({
// 		mutationKey: ["profile", profileId],
// 		// mutationFn: profileService.upsert,
// 		mutationFn: profileService.updateById,
// 		meta: {
// 			successMessage: "Profile updated successfully",
// 		},
// 		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["profile"] }),
// 	});
// };
